import { FC, useEffect, useState } from 'react';
import { Checkbox } from '@carbon/react';
import type { StartProcessResponse } from './types';
import { LaunchProcessModal } from './launch-process-modal';
import styles from './page.module.scss';

// Launches Phase 1 (address normalization via situs-sim). Occasional
// maintenance — needed before the first clustering run and after a parser
// change; results are cached on addresses, so re-runs are cheap.
export const NormalizeModal: FC<{
  open: boolean;
  onClose: () => void;
  onStarted: (proc: StartProcessResponse) => void;
}> = ({ open, onClose, onStarted }) => {
  const [onlyMissing, setOnlyMissing] = useState(true);

  useEffect(() => {
    if (open) setOnlyMissing(true);
  }, [open]);

  return (
    <LaunchProcessModal
      open={open}
      heading="Normalize Addresses"
      primaryButtonText="Run Normalization"
      url="/admin/bulk_dedupe/normalize"
      limitLabel="Limit (optional, for testing a subset)"
      buildBody={(limit) => ({
        onlyMissing,
        ...(limit === '' ? {} : { limit }),
      })}
      onClose={onClose}
      onStarted={onStarted}
    >
      <p>
        Parse &amp; normalize entity-attached addresses via situs-sim
        (libpostal). Run this before the first clustering run, or after a parser
        change.
      </p>
      <Checkbox
        id="normalize-only-missing"
        labelText="Only re-parse un-parsed addresses"
        checked={onlyMissing}
        onChange={(_e, { checked }) => setOnlyMissing(checked)}
      />
      <p className={styles.addressLine}>
        {onlyMissing
          ? 'Skips addresses that already have a parse.'
          : 'Re-parses every party-attached address — needed after a parser change (e.g. the PO-box fix).'}
      </p>
    </LaunchProcessModal>
  );
};
